import { Foods as FoodLine } from "@/svgs/images";

export const Foods = ({
  reverse,
  className,
  bottom,
}: {
  className?: string;
  reverse?: boolean;
  bottom?: boolean;
}) => {
  return (
    <div
      className={`scroll ${
        reverse ? "reverse" : ""
      } bg-repeat-x bg-center absolute ${
        bottom ? "bottom-0" : "top-0"
      } left-0 w-full${className ? ` ${className}` : ""}`}
      style={{
        backgroundImage: `url(${FoodLine.src})`,
        backgroundSize: "1427px",
        height: FoodLine.height,
        width: "100%",
      }}
    />
  );
};
